import React from "react";
import Button from "app/components/Button";
import { GoogleIcon } from "app/components/Icons/GoogleIcon";
import { useDispatch, useSelector } from "react-redux";
import { selectIsGoogleLogin } from "../../redux/selector";
import { useNavigate } from "react-router-dom";
import { actions } from "../../redux/slice";
import { userOnboardingStage } from "app/types";
import { auth, signInWithGoogle } from "utils/firebase";
import { actions as appActions } from "../../../../redux/slice";

export default function GoogleLoginButton() {
  let unsubscribeFromAuth;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isGoogleLogin = useSelector(selectIsGoogleLogin);

  React.useEffect(() => {
    unsubscribeFromAuth = auth.onAuthStateChanged((user: any) => {
      if (user) {
        responseGoogle(user.providerData);
      }
    });

    return () => {
      unsubscribeFromAuth();
      auth.signOut();
    };
  }, []);
  const responseGoogle = (response: any) => {
    let googleData = {
      email: response[0].email,
      fullName: response[0].displayName,
      profilePic: response[0].photoURL,
      googleId: response[0].uid,
    };

    dispatch(
      actions.doGoogleLogin({
        data: googleData,
        callback: (nextPage: userOnboardingStage, fullName, token) => {
          localStorage.setItem("accessToken", token);
          if (nextPage === userOnboardingStage.CREATE_PROFILE) {
            navigate(
              `/onboarding/create-profile?isGoogleLogin=true&userName=${fullName}`
            );
          } else if (nextPage === userOnboardingStage.COMPLETED) {
            navigate(`/app/home`);
            dispatch(appActions.doGetMyProfile());
            dispatch(appActions.doGetUserWorkspace({ callback() {} }));
          }
        },
      })
    );
  };
  return (
    <Button
      className="w-full h-[56px] flex items-center justify-center bg-white border border-secondary text-secondary"
      type="button"
      isLoading={isGoogleLogin}
      onClick={() => signInWithGoogle().catch(() => {})}
    >
      <div className="flex items-center gap-[10px]">
        <GoogleIcon size={24} />
        <span className="text-base font-medium text-secondary">
          Continue with Google
        </span>
      </div>
    </Button>
  );
}
